import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

export const marketRoutes: Route = {
    path: 'market',
    data: { title: 'market' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'market-product' },
        {
            path: 'market-product',
            loadComponent: () => import('./market-product/market-product.component').then((m) => m.MarketProductComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'market-product' },
        },
        {
            path: 'market-source',
            loadComponent: () => import('./market-source/market-source.component').then((m) => m.MarketSourceComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'market-source' },
        },
        {
            path: 'market-price',
            loadComponent: () => import('./market-price/market-price.component').then((m) => m.MarketPriceComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'market-price' },
        },
        {
            path: 'input-price',
            loadComponent: () => import('./input-price/input-price.component').then((m) => m.InputPriceComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'input-price' },
        },
    ],
};

